import { createStore } from "vuex";

export default createStore({
    state: {
        theme: window.localStorage.getItem('theme') ?? 'dark',
        lang: window.localStorage.getItem('lang') ?? 'ar',
        env: 'dev', // When on production use value 'prod' otherwise 'dev',
        isSearchLoader: false,
        projectData: {
            filteredProjects: null,
            projects: null,
            activeTab: 'all',
            activeFilter: null,
        },
        sectorData: {
            filteredProjects: null,
            projects: null,
            activeTab: 'all',
            activeFilter: null,
        },
    },
    getters: {
        getEnv( state ) {
            return state.env;
        },
        getCurrentTheme (state) {
            return state.theme;
        },
        getCurrentLang (state) {
            return state.lang;
        },
        // Project State Varaibles Down below
        getFilteredProjects (state) {
            return state.projectData.filteredProjects;
        },
        getProjects (state) {
            return state.projectData.projects;
        },
        getActiveTab (state) {
            return state.projectData.activeTab;
        },
        getActiveFilter (state) {
            return state.projectData.activeFilter;
        },
        // Sector State Varaibles Down below
        getFilteredSectorProjects (state) {
            return state.sectorData.filteredProjects;
        },
        getSectorProjects (state) {
            return state.sectorData.projects;
        },
        getActiveTabSector (state) {
            return state.sectorData.activeTab;
        },
        getActiveFilterSector(state) {
            return state.sectorData.activeFilter;
        },
        getSearchLoader(state) {
            return state.isSearchLoader;
        }
    },
    mutations: {
        SET_THEME(state, val) {
            state.theme = val;
        },
        SET_LANG(state, val) {
            state.lang = val;
        },
        SET_FILTERED_PROJECTS(state, val) {
            state.projectData.filteredProjects = val;
        },
        SET_PROJECTS(state, val) {
            state.projectData.projects = val;
        },
        SET_ACTIVE_TAB(state, val) {
            state.projectData.activeTab = val;
        },
        SET_ACTIVE_FILTER(state, val) {
            state.projectData.activeFilter = val;
        },
        SET_FILTERED_SECTOR_PROJECTS(state, val) {
            state.sectorData.filteredProjects = val;
        },
        SET_SECTOR_PROJECTS(state, val) {
            state.sectorData.projects = val;
        },
        SET_ACTIVE_TAB_SECTOR(state, val) {
            state.sectorData.activeTab = val;
        },
        SET_ACTIVE_FILTER_SECTOR(state, val) {
            state.sectorData.activeFilter = val;
        },
        SET_SEARCH_LOADER(state,val) {
            state.isSearchLoader = val;
        }
    },
    actions: {
        setTheme(context, newVal) {
            context.commit('SET_THEME',newVal)
        },
        setLang(context, newVal) {
            context.commit('SET_LANG',newVal)
        },
        setFilteredProjects(context, newVal) {
            context.commit('SET_FILTERED_PROJECTS',newVal)
        },
        setProjects(context, newVal) {
            context.commit('SET_PROJECTS',newVal)
        },
        setActiveTab(context, newVal) {
            context.commit('SET_ACTIVE_TAB', newVal)
        },
        setActiveFilter(context, newVal) {
            context.commit('SET_ACTIVE_FILTER', newVal)
        },
        setFilteredSectorProjects(context, newVal) {
            context.commit('SET_FILTERED_SECTOR_PROJECTS',newVal)
        },
        setSectorProjects(context, newVal) {
            context.commit('SET_SECTOR_PROJECTS',newVal)
        },
        setActiveTabSector(context, newVal) {
            context.commit('SET_ACTIVE_TAB_SECTOR', newVal)
        },
        setActiveFilterSector(context, newVal) {
            context.commit('SET_ACTIVE_FILTER_SECTOR', newVal)
        },
        setSearchLoader(context, newVal) {
            context.commit('SET_SEARCH_LOADER',newVal);
        }
    },
    modules: {}
});